export default "__VITE_ASSET__f8e3488f__"